import { Component } from "react";
import * as Sentry from "@sentry/react";
import * as s from "./errorBoundary.module.scss";
import { trademoTrackingEvents } from "@core/global/trademo-tracking";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  componentDidCatch(error, info) {
    trademoTrackingEvents("error_fallback_page", { error, stackTrace: info.componentStack });
    Sentry.captureException(error, info.componentStack);
    this.setState({ hasError: true, error: { error, componentStack: info.componentStack } });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className={s.error_boundary_container}>
          <div className={s.error_boundary_content_wrapper}>
            <p className={s.heading_text}> oops</p>
            <p className={s.subHeading_text}> something went wrong!</p>
            <button
              type="button"
              className={`${s.btn_primary}`}
              onClick={() => {
                Sentry.captureException(this.state.error.error, this.state.error.componentStack);
                window.location.reload();
              }}>
              Click here to reload
            </button>
          </div>
          <div className={s.error_image_wrapper}>
            <img width={1120} height={672} src="https://res.cloudinary.com/drzta9shk/image/upload/v1712819193/intel/misc/sww_insideproduct_z3dopw.png" />
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
